<template>
  <el-table :data="currentValue" style="width: 100%">
    <el-table-column :label="$t('orderLine.embraceFromOrderNumber')" width="120">
      <template slot-scope="scope">
        <span>{{ scope.row['orderNumber'] }}</span>
      </template>
    </el-table-column>
    <el-table-column :label="$t('orderLine.embraceFromFinish')" width="180">
      <template slot-scope="scope">
        <span>{{ scope.row['embraceFinishName'] }}</span>
      </template>
    </el-table-column>
    <el-table-column :label="$t('orderLine.embraceHeight')" width="120">
      <template slot-scope="scope">
        <span>{{ scope.row['embraceHeightInMm'] | lengthFilter }}</span>
      </template>
    </el-table-column>
    <el-table-column :label="$t('orderLine.embraceLengthLeft')" width="120">
      <template slot-scope="scope">
        <span>{{ scope.row['embraceLengthLeftInMm'] | lengthFilter }}</span>
      </template>
    </el-table-column>
    <el-table-column :label="$t('orderLine.embraceLengthRight')" width="120">
      <template slot-scope="scope">
        <span>{{ scope.row['embraceLengthRightInMm'] | lengthFilter }}</span>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
import { ConvertMillimetersToCentimeters } from '@/utils/converters';
export default {
  filters: {
    lengthFilter(value) {
      return ConvertMillimetersToCentimeters(value);
    }
  },
  props: {
    value: Object
  },
  data: () => ({
    currentValue: []
  }),
  watch: {
    value(value) {
      this.currentValue = [value];
    }
  }
};
</script>

<style lang="scss"></style>
